import React from 'react';
import { Input, Select, Col, Button } from 'antd';
import toLower from 'lodash/toLower';
import groupBy from 'lodash/groupBy';
import mapValues from 'lodash/mapValues';
import uniqBy from 'lodash/uniqBy';
import isEmpty from 'lodash/isEmpty';
import capitalize from 'lodash/capitalize';
import { Header, Title } from '$app/shared/components/Header';
import CndSelectFilter from '$app/shared/components/CndSelectFilter';
import StatusSelectFilter from '$app/shared/components/StatusSelectFilter';
import DateRangeFilter from '$app/shared/components/DateRangeFilter';
import SegmentFilter from '$app/shared/components/SegmentFilter';

const { Search } = Input;
const { Option, OptGroup } = Select;

const acceptedInvitations = (bookings) =>
  bookings.garageInvites.find((i) => toLower(i.status) === 'accepted');
const garageNameAndTerritory = (booking) => {
  let ter = 'Unknown';
  let gn = 'Unknown';

  const inv = acceptedInvitations(booking);

  if (inv) {
    gn = inv.garage.businessName;

    if (inv.garage.territory) ter = inv.garage.territory;
    else ter = inv.garage.city;
  }

  return {
    territory: capitalize(ter),
    businessName: capitalize(gn),
  };
};
const bookingsWithGarages = (bookings) => bookings.filter(acceptedInvitations).map(garageNameAndTerritory);

const group = (territories) =>
  mapValues(
    groupBy(territories, (terr) => terr.territory),
    (value) => uniqBy(value, (v) => v.businessName).map((v) => v.businessName)
  );

const SelectGarage = (props) => {
  const { bookings, onChange, value, style } = props;
  const garages = group(bookingsWithGarages(bookings));

  return (
    <div className={`filter-container ${value ? 'active' : ''}`} style={style}>
      <img src="/assets/icons/filters/spanner.svg" alt="Garage filter" />
      <Select
        key="garages"
        style={{ width: '90%' }}
        onChange={onChange}
        value={capitalize(value) || 'All Garages'}
      >
        <Option key="allGarages" value="">
          All Garages
        </Option>
        {!isEmpty(garages)
          ? Object.keys(garages).map((key) => (
              <OptGroup key={key} label={key}>
                {garages[key].map((garage) => (
                  <Option key={garage} value={garage}>
                    {(garage || '').split(' ').map(capitalize).join(' ')}
                  </Option>
                ))}
              </OptGroup>
            ))
          : ''}
      </Select>
    </div>
  );
};

const SelectCaseManager = (props) => {
  const { caseManagers, caseManagerId, onChange, value, style } = props;

  return (
    <div className={`filter-container ${value ? 'active' : ''}`} style={style}>
      <Select
        key="caseManagers"
        defaultValue="currentUser"
        onChange={onChange}
        value={caseManagerId}
        className="customer-filter"
        style={{ width: '90%' }}
      >
        <Option className="customer-filter_my-customers" key="currentUser" value="currentUser">
          My customers only
        </Option>
        <Option className="customer-filter_all-customers" key="allCustomers" value="allCustomers">
          All customers
        </Option>
        <OptGroup key="otherCustomers" label="Customers assigned to">
          {!isEmpty(caseManagers) &&
            caseManagers.map((cm) => (
              <Option className={`customer-filter_${cm.userId}`} key={cm.userId} value={cm.userId}>
                {capitalize(cm.givenName)} {capitalize(cm.familyName)}
              </Option>
            ))}
        </OptGroup>
      </Select>
    </div>
  );
};

const DashboardHeader = (props) => {
  const {
    title,
    bookings,
    segment,
    onSegmentSelect,
    selectedCndType,
    onCndTypeSelect,
    selectedStatus,
    onStatusSelect,
    searchFieldValue,
    onChangeSearch,
    garageBusinessName,
    onSelectGarage,
    caseManagers,
    caseManagerId,
    onCaseManagerChange,
    selectedDateRange,
    onDateRangeChange,
    clearAll,
  } = props;

  return (
    <Header>
      <Col span={4} style={{ minWidth: 'max-content' }}>
        <Title>{title}</Title>
      </Col>
      <Col span={20} style={{ textAlign: 'right' }}>
        <SegmentFilter value={segment} onChange={onSegmentSelect} style={{ width: 220 }} />
        <div className={`filter-container ${searchFieldValue ? 'active' : ''}`} style={{ width: 200 }}>
          <Search placeholder="Search" onChange={onChangeSearch} size="default" value={searchFieldValue} />
        </div>
        <SelectGarage
          bookings={bookings}
          onChange={onSelectGarage}
          value={garageBusinessName}
          style={{ width: 260 }}
        />
        <SelectCaseManager
          caseManagers={caseManagers}
          caseManagerId={caseManagerId}
          onChange={onCaseManagerChange}
          value={caseManagerId}
          style={{ width: 220 }}
        />
        <CndSelectFilter value={selectedCndType} onChange={onCndTypeSelect} style={{ width: 220 }} />
        <StatusSelectFilter onChange={onStatusSelect} value={selectedStatus} style={{ width: 250 }} />
        <DateRangeFilter onChange={onDateRangeChange} value={selectedDateRange} style={{ width: 200 }} />
        <Button onClick={clearAll} className="reset-filters">
          Clear all
        </Button>
      </Col>
    </Header>
  );
};

export default DashboardHeader;
